module.exports = __webpack_public_path__ + "static/33F324_A_0-c47f8b520a7448982256c3e37384d3dd.woff";